import { FormInstance, RuleObject } from 'antd/es/form';
import { Dayjs } from 'dayjs';

export enum FIELD_TYPE {
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
}
export const startDateAndEndDateValidator = (
  comparisonFieldName: string | (string | number)[],
  currentFieldType: FIELD_TYPE
) => {
  return ({ getFieldValue }: FormInstance) => ({
    validator(_: RuleObject, value: Dayjs) {
      const isStartDate = currentFieldType === FIELD_TYPE.START_DATE;

      const comparisonFieldValue: Dayjs = getFieldValue(comparisonFieldName);

      if (
        !value ||
        !comparisonFieldValue ||
        (isStartDate
          ? comparisonFieldValue?.isAfter(value)
          : comparisonFieldValue?.isBefore(value))
      )
        return Promise.resolve();

      return Promise.reject(
        new Error(
          isStartDate
            ? 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc'
            : 'Ngày kết thúc phải lớn hơn ngày bắt đầu'
        )
      );
    },
  });
};
